import Vue from 'vue';
import format from 'date-fns/format'
import VueSimpleSpinner from 'vue-simple-spinner'
import {HTTP} from '@/utils/httpCommonUtil';
import InvoiceWeekItem from '../components/InvoiceWeekItem';
import * as InvoiceFilterEnums from '@/enums/invoiceFilterEnums';
import {InvoiceStatus} from '@/enums/invoiceStatusEnum';

const SENT_INVOICES = new Set([InvoiceStatus.SUBMITTED, InvoiceStatus.PARTIALLY_PAID, InvoiceStatus.FULLY_PAID]);

export default Vue.component('invoice-week-card', {
  name: 'Invoices',
  props: {
    'week': { type: Object },
    'filters': { type: Array }
  },
  components: {
    VueSimpleSpinner,
    InvoiceWeekItem
  },
  data () {
    return {
      loadingInitialData: false,
      cardExpanded: false,
      invoiceInfo: {
        totalBillable: 0,
        totalPayable: 0,
        totalNet: 0,
        invoiceSummaries: []
      },
      filteredSummaries: [] as any[]
    }
  },
  computed: {
    totalCount(): number {
      return this.filteredSummaries.length
    },
    totalSent(): number {
      return this.filteredSummaries.filter((invoiceSummary:any) => {
        return SENT_INVOICES.has(invoiceSummary.invoiceStatusId);
      }).length;
    }
  },
  watch: {
    filters (newVal) {
      this.filterChanged();
    }
  },
  filters: {
    weekFormat (dateISO: string) {
      return format(dateISO, 'MMMM D');
    }
  },
  async created () {
    await this.loadData();
  },
  methods: {
    filterChanged () {
      const facilityIdFilters = new Set<number>(this.filters.filter((filter: any) => filter.filterTypeId === InvoiceFilterEnums.FACILITY_FILTER_TYPE).map((filter: any) => filter.id));
      const statusIdFilters = this.filters.filter((filter: any) => filter.filterTypeId === InvoiceFilterEnums.STATUS_FILTER_TYPE).map((filter: any) => filter.id);
      if (!this.invoiceInfo.invoiceSummaries) {
        this.filteredSummaries = [];
        return;
      }
      this.filteredSummaries = this.invoiceInfo.invoiceSummaries
        .filter((invoice: any) => {
          if (facilityIdFilters.size > 0) {
            return facilityIdFilters.has(invoice.facilityId);
          } else {
            return true;
          }
        }).filter((invoice: any) => {
          if (!statusIdFilters.length) {
            return true;
          }
          for (const filterStatusId of statusIdFilters) {
            if (filterStatusId === InvoiceFilterEnums.POTENTIAL_STATUS_FILTER_ID && (!invoice.invoiceId || invoice.invoiceId < 0)) {
              return true;
            } else if (filterStatusId === InvoiceFilterEnums.NOT_SUBMITTED_STATUS_FILTER_ID && invoice.invoiceStatusId <= InvoiceStatus.REVISED) {
              return true;
            } else if (filterStatusId === InvoiceFilterEnums.SUBMITTED_STATUS_FILTER_ID && (invoice.invoiceStatusId >= InvoiceStatus.SUBMITTED && invoice.invoiceStatusId <= InvoiceStatus.FULLY_PAID)) {
              return true;
            } else if (filterStatusId === InvoiceFilterEnums.IN_REVISION_STATUS_FILTER_ID && invoice.invoiceStatusId === InvoiceStatus.IN_REVISION) {
              return true;
            } else if (filterStatusId === InvoiceFilterEnums.NOT_PAID_STATUS_FILTER_ID && (invoice.invoiceStatusId !== InvoiceStatus.PARTIALLY_PAID && invoice.invoiceStatusId !== InvoiceStatus.FULLY_PAID) ) {
              return true;
            } else if (filterStatusId === InvoiceFilterEnums.PARTIALLY_PAID_STATUS_FILTER_ID && invoice.invoiceStatusId === InvoiceStatus.PARTIALLY_PAID) {
              return true;
            } else if (filterStatusId === InvoiceFilterEnums.FULLY_PAID_STATUS_FILTER_ID && invoice.invoiceStatusId === InvoiceStatus.FULLY_PAID) {
              return true;
            }
          }
          return false;
        });
    },
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.loadData();
      }
    },
    async loadData () {
      this.filteredSummaries = [];
      let showLoadingSpinnerTimeout = setTimeout(() => {
        this.loadingInitialData = true;
      }, 0);
      try {
        const toSend = format(this.week.startDate, 'YYYY-MM-DD');
        const response = await HTTP.get('/api/invoices?invoiceStartDate=' + toSend);
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Invoice Information.");
        }
        this.invoiceInfo = response.data.data;
        this.filterChanged();
      } catch (err) {
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Invoice Information.'
        });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoices/cards/InvoiceWeekCard.ts